import DisplayObject = createjs.DisplayObject;

import Native from "./Native";
import Utils from "./utils";

declare var window: any;

export default class WebLaunchHelper {

    static isRunFromLauncher: boolean = !!Utils.getParameterByName('web-launcher');
    static haveLongpressExit: boolean = !!Utils.getParameterByName('longpress-exit');

    /**
     * Initialize web-launcher mode, if enabled in the URL.
     *
     * This will make Native.exitGame perform a 'history back'. Useful if the game
     * is started from a launcher, so that existing the game returns to the launcher.
     *
     */
    public static init() {

        if (this.isRunFromLauncher) {
            Native.exitGame = () => {
                // It the game is ran using the launcher,
                // go back to launcher on game quit.
                window.history.back();
                return;
            };
        }
    }

    /**
     * Add a 10-second-hold-to-exit to the given display object, if longpress-exit is enabled in the URL.
     *
     * This is useful to escape from the game if it's in presentation mode (full screen with no way to
     * control the browser).
     *
     * @param {createjs.DisplayObject} displayObject
     */
    public static addExitListener(displayObject: DisplayObject) {

        if (!WebLaunchHelper.haveLongpressExit)
            return;

        console.log('Installing long-press-to-exit handler');

        displayObject.removeAllEventListeners('click');

        // 10 second hold to change launchers
        let lastTimerId = null;
        displayObject.on('mousedown', () => {
            if (lastTimerId) window.clearTimeout(lastTimerId);
            lastTimerId = window.setTimeout(() => {
                // we're in http://xxx/game/content/index.html, and we wish to return to the game list at
                // http://localhost/
                window.location.href = '../../';
            }, 10*1000);
            console.log('Timer set');
        });
        displayObject.on('pressup', () => {
            window.clearTimeout(lastTimerId);
            lastTimerId = null;
            console.log('Timer cleared');
        });

    }

}


// WEBPACK FOOTER //
// ../lib/src/WebLaunchHelper.ts